import { useEffect, useState } from 'react'

import moment from 'moment'

import redTriangle from '../../../assets/icons/redTriangle.png'
import { fontSizes, fontWeights } from '../../../constants/salesStyles'
import { useSelector } from '../../../modules/store/customSelector'

import styles from './styles.module.scss'

const TrialExpiryBanner = () => {
    const [daysRemaining, setDaysRemaining] = useState<undefined | number>()

    const paymentInfo = useSelector(state => state.userData.paymentInfo)
    const paymentInfoLoaded = useSelector(state => state.userData.paymentInfoLoaded)
    const activeServiceInfo = useSelector(state => state.userData.activeServiceInfo)

    const getTrialDueText = () => {
        if (daysRemaining === undefined) return null

        switch (daysRemaining) {
            case 5:
                return (
                    <>
                        До окончания пробного периода осталось <b>5 дней</b>.
                    </>
                )
            case 4:
                return (
                    <>
                        До окончания пробного периода осталось <b>4 дня</b>.
                    </>
                )
            case 3:
                return (
                    <>
                        До окончания пробного периода осталось <b>3 дня</b>.
                    </>
                )
            case 2:
                return (
                    <>
                        До окончания пробного периода осталось <b>2 дня</b>.
                    </>
                )
            case 1:
                return (
                    <>
                        Пробный период заканчивается <b>сегодня</b>.
                    </>
                )
            case 0:
                return <>Пробный период закончился.</>
            default:
                return daysRemaining > 0 ? (
                    <>
                        До окончания пробного периода осталось <b>{daysRemaining} дней</b>.
                    </>
                ) : null
        }
    }

    useEffect(() => {
        if (!activeServiceInfo?.expireDate) return

        const targetDate = moment(activeServiceInfo.expireDate)
        const currentDate = moment()
        setDaysRemaining(targetDate.diff(currentDate, 'days'))
    }, [activeServiceInfo])

    // Show banner ONLY if:
    // 1. paymentInfo has been loaded (to avoid showing before API call completes)
    // 2. NO paymentInfo (404 from getAccountPaymentInfo) - means no tariff selected
    // 3. AND trial is ending (daysRemaining < 5)
    if (!paymentInfoLoaded) return null
    const shouldShow = !paymentInfo && daysRemaining !== undefined && daysRemaining < 5
    if (!shouldShow) return null

    return (
        <div className={styles.wrap}>
            <img src={redTriangle} alt="redTriangle" className={styles.icon} />
            <div>
                <p style={{ fontSize: fontSizes.xs, fontWeight: fontWeights.normal }}>
                    {getTrialDueText()} Пожалуйста, выберите подходящий тариф по <a href="/admin/billing">ссылке</a>.
                    <br />
                    и свяжитесь с менеджером в Telegram{' '}
                    {/* Временно скрыто: поддержка в МАКС
                        <a href="https://max.ru/u/f9LHodD0cOIAVt7Zg_ukFhe6Qw_5sgNWro0T4-_WyxIKxbVugh-hydSRlno" target="_blank" rel="noopener noreferrer">
                            МАКС +79365150373
                        </a> или Telegram{' '}
                    */}
                    <a href="https://t.me/partsautoexpert_bot" target="_blank" rel="noopener noreferrer">
                        @partsautoexpert_bot
                    </a>
                </p>
            </div>
        </div>
    )
}

export default TrialExpiryBanner
